import RatingLabel from './RatingLabel';

// export { TextProps } from './RatingLabel';
export default RatingLabel;
